let isDown = false;
const subscriptions: callback[] = [];

export function init(): void {
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && !isDown) {
      isDown = true;

      subscriptions.forEach(callback => {
        callback(true);
      });
    }
  });

  window.addEventListener('keyup', (event) => {
    if (event.key === 'Tab') {
      isDown = false;

      subscriptions.forEach(callback => {
        callback(false);
      });
    }
  });
}

export function subscribe(callback: callback): Subscription {
  subscriptions.push(callback);

  return {
    unsubscribe: () => {
      subscriptions.splice(subscriptions.indexOf(callback), 1);
    },
  };
}

export type Subscription = {
  unsubscribe: () => void;
}

type callback = (value: boolean) => void;
